<template>
  <div>
    <div class="footer">
  
      <div class="footer-about">
        <div class="contact">
          <div class="contact-div">{{ci}}</div>
          <div class="contact-details">
            <div>{{ci1}}：{{ischinese == "cn" ?this.address:this.address_en}}</div>
            <!-- <div class="divtel">{{ci2}}：{{this.tel}}</div> -->
          </div>
          <div class="contact-details">
            <div>{{ci3}}：{{this.email}}</div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <span>
          Copyright {{this.year}} 深圳前海融森科技有限公司版权所有 |
          <a style="color:red" href="http://www.beian.miit.gov.cn">粤IPC备18131974号</a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Btfooter",
  data() {
    return {
      tel: "",
      address: "",
      address_en: "",
      email: "",
      year: "",

      ischinese: "en",
      home: "首页",
      service: "我们的服务",
      service1: "品牌代运管理",
      service2: "多模式渠道管理",
      service3: "供应链管理",
      service4: "数据管理",
      innovate: "创新",
      news: "新闻中心",
      about: "关于我们",
      join: "加入我们",
      ci: "Contact information",
      ci1: "Address",
      ci2: "电话",
      ci3: "Email",
    };
  },
  methods: {
    getList() {
      this.$http
        .post("/api/dashu/footer/footerList", {})
        .then(res => {
          // console.log(res)
          var code = res.data.code;
          if (code === 0) {
            this.tel = res.data.data.about.telphone;
            this.address = res.data.data.about.address;
            this.address_en = res.data.data.about.address_en;
            this.email = res.data.data.about.email;
          }
        })
    },
    routerdetails(topnum) {
      this.$router.push({
        name: "Aservice",
        query: { topnum: topnum }
      });
    }
  },
  created() {
    this.getList();
    var now = new Date();
    var year = now.getFullYear(); //获取当前年份
    this.year = year;
    
    this.ischinese = "en";
    if (this.ischinese == "en") {
      this.home = "HomePage";
      this.service = "OurServices";
      this.service1 = "BrandTransportationManagement";
      this.service2 = "Multi-modeChannelManagement";
      this.service3 = "SupplyChainManagement";
      this.service4 = "DataManagement";
      this.innovate = "Innovation";
      this.news = "InformationCenter";
      this.about = "AboutUs";
      this.join = "JoinUs";
      this.ci = "Contact information";
      this.ci1 = "Address";
      this.ci2 = "Tel";
      this.ci3 = "Email";
    }
  }
};
</script>
<style scoped>
.footer {
  border-top: 15px solid #76c3a2;
  background: #2e3231;
  margin: 0 auto;
  width: 100%;
  min-width: 1200px;
  height: 476px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.footer-nav {
  width: 50%;
  margin: 0 15%;
  padding: 3% 10% 84px;
  color: white;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.footer-about {
  width: 50%;
  margin: 0 15%;
  padding: 6% 10% 3% 10%;
  color: white;
  display: flex;
  justify-content: space-between;
}
.footer-bottom {
  width: 50%;
  margin: 0 15%;
  padding: 1% 10%;
  color: red;
}
.footer-bottom {
  text-align: center;
}
.contact {
  width: 100%;
}
.contact-div {
  font-size: 26px;
  padding-bottom: 40px;
  font-weight: bold;
}
.contact-details {
  display: flex;
}
.contact-details div {
  width: 50%;
  padding-bottom: 30px;
  white-space: nowrap;
}
.divtel {
  margin-left: 155px;
}
.el-dropdown-link {
  cursor: pointer;
  color: white;
  font-size: 16px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
